/**
 * Author: Claude Code using Sonnet 4.5 / Claude Haiku 4.5
 * Date: 2025-11-11 / 2025-12-24
 * PURPOSE: Compact app header with ARC-inspired colorful branding and colorful emoji dividers.
 * Zero margins for edge-to-edge layout. Includes full AppNavigation component.
 * Updated to include OpenRouter sync status banner above header.
 * SRP/DRY check: Pass - Single responsibility (header layout), reuses AppNavigation component
 */
import React from 'react';
import { Link } from 'wouter';
import { AppNavigation } from './AppNavigation';
import { OpenRouterSyncBanner } from './OpenRouterSyncBanner';

export function AppHeader() {
  return (
    <>
      <OpenRouterSyncBanner />
      <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-12 items-center justify-between gap-4 px-4">
        <Link href="/">
          <div className="flex items-center gap-3 cursor-pointer group min-w-fit">
            {/* ARC-inspired colorful logo */}
            <div className="flex flex-col gap-0.5 group-hover:scale-110 transition-transform">
              <div className="flex gap-0.5 text-[10px] leading-none">
                <span>🟥</span>
                <span>🟧</span>
                <span>🟨</span>
              </div>
              <div className="flex gap-0.5 text-[10px] leading-none">
                <span>🟩</span>
                <span>🟦</span>
                <span>🟪</span>
              </div>
            </div>
            <div className="flex flex-col">
              <div className="font-bold text-base leading-tight whitespace-nowrap">ARC Explainer</div>
              <div className="text-[9px] text-muted-foreground leading-none whitespace-nowrap">ARC 1 🟥 ARC 2 🟨 ARC 3 🟦</div>
            </div>
          </div>
        </Link>

        <div className="flex flex-1 items-center justify-end overflow-x-auto">
          <AppNavigation />
        </div>
      </div>
    </header>
    </>
  );
}
